<!-- Spinner -->
<div class="overlay-content" *ngIf="isLoading$ | async">
    <mat-progress-spinner color="blue" mode="indeterminate"></mat-progress-spinner>
</div>
<!-- Spinner -->